import * as React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { LuArrowDownRight } from "react-icons/lu"
import { gtmTracking } from "@/utils/gtm-tracking"

const ProductHeader = ({
  kicker,
  title,
  description,
  links,
  image,
  children,
  buttonText,
}) => {
  const { t } = useTranslation()

  return (
    <section className="container-fluid product-header">
      <div className="row">
        <div className="col-xs-12 col-md-7">
          <h1 className="heading-kicker">{kicker}</h1>
          <span className="h1 mb-6">{title}</span>

          <div className="product-header__footer">
            <Link
              to="/signup/"
              className="btn btn--lg"
              onClick={gtmTracking(
                "CTA Click",
                buttonText || t("common.try-free"),
                "Product Header",
              )}
            >
              {buttonText || t("common.try-free")}
            </Link>
            {children && children}
          </div>
        </div>
        <div className=" center-xs col-md-1">
          <div className="divider divider--vertical-dashed"></div>
        </div>
        <div className="col-xs-12 col-md-4 product-header__description">
          <p>{description}</p>
          <div className="product-header__description-links">
            {links.map(link => (
              <Link
                to={link.to}
                className="text-link text-link--bare text-link--underline product-header__description-link"
                key={link.text}
                onClick={gtmTracking("Link Click", link.text, "Product Header")}
              >
                <LuArrowDownRight className="product-header__description-link-icon" />
                <span className="product-header__description-link-text">
                  {link.text}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="product-header__image">
        <GatsbyImage image={getImage(image.src)} alt={image.alt} />
      </div>
    </section>
  )
}

export default ProductHeader
